import { useTranslation } from "react-i18next";
import { Card, CardBody } from "react-bootstrap";
import { useEffect, useState } from "react";
import crudApi from "@serie3/common/api/crudApi";
import DashboardEndpoints from "@serie3/mymediaplanner/Modules/Dashboard/endpoints";
import ListElement from "./ListElement";
import getDashboardUrl from "@serie3/mymediaplanner/Modules/Dashboard/Domain/getDashboardUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";

const PlanOverview = ({ monthYear, onEdit }) => {
  const [planData, setPlanData] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const getData = async () => {
      const url = getDashboardUrl(DashboardEndpoints.plans, monthYear);
      const response = await crudApi.justGet(url);
      if (response.ok) setPlanData(response.data);
    };
    getData();
  }, [monthYear]);

  return (
    <Card style={{ borderRadius: 16, border: "1px solid #eaecf0", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
      <CardBody>
        <h4 className="page-section-header" style={{ marginBottom: 16 }}>
          <span className="page-section-header-icon" style={{ background: "rgba(3,142,220,0.12)" }}>
            <FontAwesomeIcon icon={faCalendarAlt} style={{ color: "#038edc" }} />
          </span>
          {t("Backend.Dashboard.PlanTitle", "Plan Overview")}
        </h4>
        <div>
          {planData?.nextPlanned?.[0] && (
            <ListElement
              title={t("Backend.Dashboard.NextPlanned")}
              data={planData.nextPlanned[0].post.title}
              icon="uil uil-calendar-alt"
              onClick={() => onEdit?.(planData.nextPlanned[0].post)}
            />
          )}
          {planData?.lastPosted?.[0] && (
            <ListElement
              title={t("Backend.Dashboard.LastPosted")}
              data={planData.lastPosted[0].post.title}
              icon="uil uil-history"
              onClick={() => onEdit?.(planData.lastPosted[0].post)}
            />
          )}
          {planData?.lastEdited?.[0] && (
            <ListElement
              title={t("Backend.Dashboard.LastEdited")}
              data={planData.lastEdited[0].title}
              icon="uil uil-edit"
              onClick={() => onEdit?.(planData.lastEdited[0])}
            />
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default PlanOverview;
